import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useExportState = createStateHook(
  AppStoreProvider,
  state => state.pages.export
)
export const useNextExportState = () =>
  createNextHook(AppStoreProvider, state => state.pages.export)
